import React from 'react';
import Planetariumshow2023 from 'views/Planetariumshow2023';

const AccountGeneralPage = () => {
  return <Planetariumshow2023 />;
};

export default AccountGeneralPage;